import { client } from "../../../api/axiosConfig";

export const getLicenseSummary = (userId) => {
    return client.get(`/licenses/summary/${userId}`);
};

export const assignLicense = (adminId, email) => {
    return client.post("/licenses/assign", {
        adminId,
        email,
    });
};

export const unassignLicense = (assignmentId) => {
    return client.delete(`/licenses/assign/${assignmentId}`);
};

export const resendLicenseEmail = (assignmentId) => {
    return client.post(`/licenses/resend/${assignmentId}`);
};